const PurchaseType = {
  SET_SUBMIT_REQUESTS_TODOLIST: 'SET_SUBMIT_REQUESTS_TODOLIST',
  SET_SUBMIT_TODO_LIST_COUNT: 'SET_SUBMIT_TODO_LIST_COUNT',
  SET_SUBMIT_SELECTED_IDS_ARRAY: 'SET_SUBMIT_SELECTED_IDS_ARRAY',
  SET_SUBMIT_SORT_DATA: 'SET_SUBMIT_SORT_DATA',
  CATEGORY: 'CATEGORY',
  SET_SUBMITODO_LIST_COUNT: 'SET_SUBMITODO_LIST_COUNT',
};

export default PurchaseType;
